import type { CustomTheme } from '../../../types/custom-theme';
import type { Product } from '../../../types/product';

const baseCardShared: CustomTheme.CSSProperties = {
  cursor: 'pointer',
};

const base = {
  interactive: {
    ...baseCardShared,
    boxShadow: 'cardList',
    '&:focus, &:focus-within': {
      outline: '2px solid',
      outlineColor: 'auto',
      outlineOffset: '8px',
      a: {
        outline: 'none',
      },
    },
  },
  raised: {
    ...baseCardShared,
    boxShadow: 'cardList',
  },
  template: {
    backgroundColor: 'coolGrey.5',
    padding: 's16',
  },
  hasDarkBackground: {
    '&:focus, &:focus-within': {
      outlineColor: 'white',
    },
  },
};

const card: Product.VariantKeyModes<CardVariantsType> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type CardVariantsType = 'interactive' | 'raised' | 'template' | 'hasDarkBackground';
export const cardVariants = Object.keys(base) as CardVariantsType[];

export default card;
